import { RolePermissions } from '@/types/Role';
import { ROUTES } from '@/route/routes.constants';
import { ROLE } from '@/role.constant';

export const ROLE_PERMISSIONS: RolePermissions[] = [
  {
    role: ROLE.ADMINISTRATOR,
    permissions: [
      { resource: 'inspections', action: 'read' },
      { resource: 'inspections', action: 'write' },
      { resource: 'inspections', action: 'create' },
      { resource: 'inspections', action: 'delete' },
      { resource: 'tooling', action: 'read' },
      { resource: 'tooling', action: 'write' },
      { resource: 'tooling', action: 'create' },
      { resource: 'tooling', action: 'delete' },
    ],
    allowedRoutes: [
      ROUTES.INSPECTIONS,
      ROUTES.INSPECTION_DETAILS,
      ROUTES.INSPECTION_MODULE,
      ROUTES.TOOLING,
    ]
  },
  {
    role: ROLE.QC_INSPECTOR,
    permissions: [
      { resource: 'inspections', action: 'read' },
      { resource: 'inspections', action: 'write' },
      { resource: 'inspections', action: 'create' },
      { resource: 'inspections', action: 'delete' },
      { resource: 'tooling', action: 'read' },
      { resource: 'tooling', action: 'write' },
      { resource: 'tooling', action: 'create' },
      { resource: 'tooling', action: 'delete' },
    ],
    allowedRoutes: [
      ROUTES.INSPECTIONS,
      ROUTES.INSPECTION_DETAILS,
      ROUTES.INSPECTION_MODULE,
      ROUTES.TOOLING,
    ]
  },
  {
    role: ROLE.REVIEWER,
    permissions: [
      { resource: 'inspections', action: 'read' },
      { resource: 'inspections', action: 'write' },
      { resource: 'inspections', action: 'create' },
      { resource: 'inspections', action: 'delete' },
      { resource: 'tooling', action: 'read' },
      { resource: 'tooling', action: 'write' },
      { resource: 'tooling', action: 'create' },
      { resource: 'tooling', action: 'delete' },
    ],
    allowedRoutes: [
      ROUTES.INSPECTIONS,
      ROUTES.INSPECTION_DETAILS,
      ROUTES.INSPECTION_MODULE,
      ROUTES.TOOLING,
    ]
  },
  {
    role: ROLE.PLANNER,
    permissions: [
      { resource: 'inspections', action: 'read' },
      { resource: 'inspections', action: 'write' },
      { resource: 'inspections', action: 'create' },
      { resource: 'inspections', action: 'delete' },
      { resource: 'tooling', action: 'read' },
      { resource: 'tooling', action: 'write' },
      { resource: 'tooling', action: 'create' },
      { resource: 'tooling', action: 'delete' },
    ],
    allowedRoutes: [
      ROUTES.INSPECTIONS,
      ROUTES.INSPECTION_DETAILS,
      ROUTES.INSPECTION_MODULE,
      ROUTES.TOOLING,
    ]
  },
  {
    role: ROLE.CARTON_INSPECTOR,
    permissions: [
      { resource: 'inspections', action: 'read' },
      { resource: 'inspections', action: 'write' },
      { resource: 'inspections', action: 'create' },
      { resource: 'inspections', action: 'delete' },
      { resource: 'tooling', action: 'read' },
      { resource: 'tooling', action: 'write' },
      { resource: 'tooling', action: 'create' },
      { resource: 'tooling', action: 'delete' },
    ],
    allowedRoutes: [
      ROUTES.INSPECTIONS,
      ROUTES.INSPECTION_DETAILS,
      ROUTES.INSPECTION_MODULE,
      ROUTES.TOOLING,
    ]
  },
];

export const getRolePermissions = (role: string): RolePermissions | undefined => {
  return ROLE_PERMISSIONS.find(rp => rp?.role.toLowerCase() === role.toLowerCase());
};

export const getAllowedRoutesForRoles = (roles: string[]): string[] => {
  const allowedRoutes = new Set<string>();

  roles.forEach(role => {
    const rolePerms = getRolePermissions(role.toLowerCase());
    if (rolePerms) {
      rolePerms.allowedRoutes.forEach(route => allowedRoutes.add(route));
    }
  });

  return Array.from(allowedRoutes);
}; 